import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'radarChart',
  props: ['chart'],
  methods: {
    initRadarChart: function initRadarChart(data) {
      var that = this;
      var option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,250,0.2)',
          formatter: function formatter(params) {
            var str = params.name;
            data.indicatorData.forEach(function (item, index) {
              str += "<br/>".concat(item.name, ":").concat(params.data.value[index]).concat(item.unit ? "(".concat(item.unit, ")") : '');
            });
            return str;
          }
        },
        legend: {
          type: 'scroll',
          bottom: 10,
          data: data.legendData
        },
        visualMap: {
          top: 'middle',
          right: 10,
          color: ['red', 'yellow'],
          calculable: true
        },
        radar: {
          indicator: data.indicatorData
        },
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.clear();
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};